
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertOffFilled as ObiAlertOffFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alert-off-filled.js';
 
 
 

 
 export const ObiAlertOffFilled = createComponent({
   react: React,
   tagName: 'obi-alert-off-filled',
   elementClass: ObiAlertOffFilledElement,
   events: {
     
   }
  });
 
 